import { useEffect, useState } from "react";
import { FaBell } from "react-icons/fa6";
import { useAuth } from "../context/AuthContext";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export const UserNotificationIcon = ({ user }) => {
  const { authAxios, token } = useAuth();
  const [unseenMessageCount, setUnseenMessageCount] = useState(0);

  useEffect(() => {
    setInterval(() => {
      fetchCurrentUserUnseenMessageCount();
    }, 10000);
  }, []);

  useEffect(() => {
    fetchCurrentUserUnseenMessageCount();
  }, [user]);

  const fetchCurrentUserUnseenMessageCount = async () => {
    if (
      user === null ||
      user === undefined ||
      token === null ||
      token === undefined
    )
      return;
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };
      const response = await authAxios().get(
        "/api/backoffice/users/unseen_messages",
        config,
      );

      setUnseenMessageCount(response.data);
    } catch (e) {
      console.log("Error catch");
      console.log(e);
    }
  };

  return (
    <Col
      as={Link}
      className={"axis-notification-wrapper text-end text-axis-offblack"}
      to={`/my_messages`}
    >
      <FaBell size={36} />
      {unseenMessageCount > 0 ? (
        <div className={"axis-badge-number"}>{unseenMessageCount}</div>
      ) : null}
    </Col>
  );
};
